import { render } from "./07_DashboardCallLog.vue?vue&type=template&id=22d03096"
import script from "./07_DashboardCallLog.vue?vue&type=script&lang=js"
export * from "./07_DashboardCallLog.vue?vue&type=script&lang=js"

import "./07_DashboardCallLog.vue?vue&type=style&index=0&id=22d03096&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__